/* eslint-disable */
import React, { Suspense } from 'react';
import { HashRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import NetworkProvider from './contexts/networkContext';
import TaskProvider from './contexts/taskContext';
import FocusModeProvider from './contexts/focusModeContext';
import AjaxInterceptors from './utils/AjaxInterceptors';
import AppRoute from './routes/index';
import Loader from './components/Loader/Loader';
import ScrollToTop from './ScrollToTop';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
//import { SnackbarProvider } from 'notistack';
import { messaging } from './init-fcm';

function App() {
  return (
    // <SnackbarProvider maxSnack={3}>
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <HashRouter>
        <ScrollToTop />
        <CssBaseline />
        <Suspense fallback={<Loader />}>
          <NetworkProvider>
            <TaskProvider>
              <FocusModeProvider>
                <>
                  <AjaxInterceptors />
                  <AppRoute />
                </>
              </FocusModeProvider>
            </TaskProvider>
          </NetworkProvider>
        </Suspense>
      </HashRouter>
    </MuiPickersUtilsProvider>
    // {/* </SnackbarProvider> */}
  );
}

export default App;
